import React from "react";
import "../assets/css/fontawesome.css";
import "../assets/css/slick.css";
import "../assets/css/lightgallery.min.css";
import "../assets/css/animate.css";
import "../assets/css/style.css";

const Progress = () => {
  return (
    <>
      <section className="st-dark-bg">
        <div className="st-height-b100 st-height-lg-b80"></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="st-skill-wrap">
                <div className="st-skill-heading">
                  <h2 className="st-skill-title">Backend Development Skills</h2>
                  <div className="st-skill-subtitle">
                    My expertise in backend development spans various
                    technologies and practices. I have a deep understanding of
                    server-side programming, databases, and API integrations,
                    which allow me to build robust and scalable applications.
                    Below are the skills I excel in within this field:
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="st-height-b0 st-height-lg-b30"></div>
              <div className="st-progressbar-wrap">
                <div className="st-single-progressbar">
                  <div className="st-progressbar-heading">
                    <h3 className="st-progressbar-title">Node.js</h3>
                    <div
                      className="st-progressbar-percentage wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.5s"
                    >
                      90%
                    </div>
                  </div>
                  <div className="st-progressbar" data-progress="90">
                    <div className="st-progressbar-in wow fadeInLeft"></div>
                  </div>
                </div>
                <div className="st-height-b30 st-height-lg-b20"></div>
                <div className="st-single-progressbar">
                  <div className="st-progressbar-heading">
                    <h3 className="st-progressbar-title">Express.js</h3>
                    <div
                      className="st-progressbar-percentage wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.5s"
                    >
                      85%
                    </div>
                  </div>
                  <div className="st-progressbar" data-progress="85">
                    <div className="st-progressbar-in wow fadeInLeft"></div>
                  </div>
                </div>
                <div className="st-height-b30 st-height-lg-b20"></div>
                <div className="st-single-progressbar">
                  <div className="st-progressbar-heading">
                    <h3 className="st-progressbar-title">MongoDB</h3>
                    <div
                      className="st-progressbar-percentage wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.5s"
                    >
                      80%
                    </div>
                  </div>
                  <div className="st-progressbar" data-progress="80">
                    <div className="st-progressbar-in wow fadeInLeft"></div>
                  </div>
                </div>
                <div className="st-height-b30 st-height-lg-b20"></div>
                <div className="st-single-progressbar">
                  <div className="st-progressbar-heading">
                    <h3 className="st-progressbar-title">SQL</h3>
                    <div
                      className="st-progressbar-percentage wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.5s"
                    >
                      45%
                    </div>
                  </div>
                  <div className="st-progressbar" data-progress="45">
                    <div className="st-progressbar-in wow fadeInLeft"></div>
                  </div>
                </div>
                <div className="st-height-b30 st-height-lg-b20"></div>
                <div className="st-single-progressbar">
                  <div className="st-progressbar-heading">
                    <h3 className="st-progressbar-title">Postman</h3>
                    <div
                      className="st-progressbar-percentage wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.5s"
                    >
                      70%
                    </div>
                  </div>
                  <div className="st-progressbar" data-progress="70">
                    <div className="st-progressbar-in wow fadeInLeft"></div>
                  </div>
                </div>
                <div className="st-height-b30 st-height-lg-b20"></div>
                <div className="st-single-progressbar">
                  <div className="st-progressbar-heading">
                    <h3 className="st-progressbar-title">Git</h3>
                    <div
                      className="st-progressbar-percentage wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.5s"
                    >
                      85%
                    </div>
                  </div>
                  <div className="st-progressbar" data-progress="85">
                    <div className="st-progressbar-in wow fadeInLeft"></div>
                  </div>
                </div>
                <div className="st-height-b30 st-height-lg-b20"></div>
                <div className="st-single-progressbar">
                  <div className="st-progressbar-heading">
                    <h3 className="st-progressbar-title">Render</h3>
                    <div
                      className="st-progressbar-percentage wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.5s"
                    >
                      55%
                    </div>
                  </div>
                  <div className="st-progressbar" data-progress="55">
                    <div className="st-progressbar-in wow fadeInLeft"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Progress;
